import {createStrokeSVG} from './TEMPLATE'

// tabler: list
export const ListSparkle_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M9 6l11 0',
    'M9 12l11 0',
    'M9 18l11 0',
    'M5 6l0 .01',
    'M5 12l0 .01',
    'M5 18l0 .01',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
